import React from 'react'
import ImageDescription from '../../Components/ImageDescription/ImageDescription'
import imgLessHeadache from '../../assets/news-events/LessHeadache.png'
import TextCaption from '../../Components/TextCaption/TextCaption'
import LessHeadache_01 from '../../assets/news-events/LessHeadache_01.png'
import LessHeadache_02 from '../../assets/news-events/LessHeadache_02.png'

const LessHeadache = () => {
  return (
    <div>
      <ImageDescription
        imageSrc={imgLessHeadache}
        title={"Less Headache with Maintenance Plans"}
        paragraphs={[
          "In the day-to-day life of the industry, we know: keeping equipment running without surprises is essential to ensure productivity and avoid losses. Even so, unexpected failures are still a reality that keeps many managers up at night. It is precisely to change this scenario that HANSA-FLEX created the maintenance plans."
          , "Text: Gabriela Nascimento and Tatiana Schrader, May 21, 2025",
        ]}
      />

      <TextCaption
        title='Why having a maintenance plan makes all the difference'
        paragraph="Taking care of equipment before it has problems is the best strategy to avoid unexpected downtime. A well-made maintenance plan ensures scheduled inspections and changes, increasing the safety and performance of the entire hydraulic and pneumatic system. Result? Fewer unforeseen events, more productivity and much more peace of mind."
      />

      <TextCaption
        title='How HANSA-FLEX helps you take care of your operation'

      />

      <ImageDescription
        imageSrc={LessHeadache_01}

        paragraphs={[
          "Each operation has its own particularities, and HANSA-FLEX takes this seriously. It all starts with a thorough analysis of your systems. With this information in hand, we put together a tailor-made maintenance plan, taking into account how the equipment is used, which are most critical, and the history of failures. Oh, and of course: we only use original parts and have specialized technicians to ensure that everything works perfectly."
        ]}
      />

      <TextCaption
        title={"Benefits you feel on a daily basis"}
        paragraph="By entrusting the maintenance of your systems to HANSA-FLEX, you will notice a difference right away:"
        bulletPoints={[
          "More available and reliable equipment.;",
          "Less rush with emergencies and unforeseen events.",
          "More predictable maintenance costs.",
          "Equipment that lasts much longer.",
          "Support from those who understand the subject, whenever you need it.",

        ]}
      />
      <TextCaption
        paragraph='All this translates into more security, better performance and much smoother management.'
      />

      <ImageDescription
        imageSrc={LessHeadache_02}
      />

      <TextCaption
        title={"Your Operation at the Center of Our Solutions"}

        paragraph="Here at HANSA-FLEX, we know that downtime is synonymous with loss. That's why we work to be more than suppliers: we want to be your partners on the journey for more efficiency and safety."
      />
      <TextCaption
        paragraph='Want to take the headache out of your routine? Talk to our experts and learn about our preventive and corrective maintenance solutions!'
      />

    </div>
  )
}

export default LessHeadache